<template>
  <v-container>
    <vue-release-notes :releases="releases" />
  </v-container>
</template>

<script>
import VueReleaseNotes from "vue-release-notes";
import "vue-release-notes/dist/vue-release-notes.css";

export default {
  name: "ReleaseNotes",

  components: {
    VueReleaseNotes
  },

  data() {
    return {
      releases: [
        {
          version: "1.5.1",
          date: new Date(2020, 12, 3),
          changes: [
            {
              type: "fix",
              description:
                "Les fiches bloquées sont maintenant éditables pour les applicateurs"
            }
          ]
        },
        {
          version: "1.5",
          date: new Date(2020, 12, 2),
          changes: [
            {
              type: "feat",
              description: "Ajout du système de monitoring et de logs"
            },
            {
              type: "feat",
              description:
                "Meilleure gestion d'enregistrement et de transfert des fiches ainsi que des médias"
            },
            {
              type: "feat",
              description: "Meilleure gestion des erreurs et message d'erreur"
            },
            {
              type: "fix",
              description:
                "Correction d'un bug qui empêchait le transfert des médias quand une erreur survenait lors du transfert de la fiche"
            },
            {
              type: "fix",
              description:
                "Correction d'un bug qui empêchait le transfert d'une fiche avec médias si ces derniers étaient en erreur"
            },
            {
              type: "fix",
              description:
                "Correction d'un bug qui empêchait le transfert de la totalité des médias si un média était en erreur"
            },
            {
              type: "fix",
              description:
                "Correction d'un bug qui empêchait la redirection vers la page de connexion lorsque la session était expirée"
            },
            {
              type: "fix",
              description:
                "Correction d'un bug qui empêchait le transfert d'une fiche lorsque celle-ci était déjà présente dans Base Serveur"
            },
            {
              type: "fix",
              description:
                "Correction d'un bug qui empêchait le transfert d'un média avec photo"
            }
          ]
        },
        {
          version: "1.4.14",
          date: new Date(2020, 11, 17),
          changes: [
            {
              type: "fix",
              description:
                "Correction d'un bug qui causait la perte d'une fiche créée dans Base Tablette lorsqu'on récupérait une fiche depuis la Base Serveur"
            },
            {
              type: "fix",
              description:
                "Correction d'un bug qui causait la suppression d'une fiche de Base Tablette lorsqu'on enregistrait cette même fiche 2 fois de puis la base serveur"
            },
            {
              type: "feat",
              description:
                "Dans la page détaille d'une fiche, ajout d'un bouton qui permet de supprimer une fiche de la Base Tablette"
            },
            {
              type: "feat",
              description: "Ajout de la page notes de version"
            }
          ]
        }
      ]
    };
  }
};
</script>

<style></style>
